import { isBlankString, isValidEmail, isValidPhone } from 'shared/utils';

export const deviceTypeWired = 'Wired';

export function getUnitOptionLabel(u) {
  if (u.tenant_count === 0) return u.name;
  if (u.tenant_count === 1) return `${u.name} (1 occupant)`;
  return `${u.name} (${u.tenant_count} occupants)`;
}

export function validateTenantData(tenant, validateContact) {
  if (!tenant.first_name || !tenant.last_name) {
    return 'First and last name is required';
  }

  if (validateContact && (!tenant.email && !tenant.phone)) {
    return 'Email or phone is required';
  }

  if (!isBlankString(tenant.phone) && !isValidPhone(tenant.phone)) {
    return 'Must enter a valid security contact phone number';
  }
  if (!isBlankString(tenant.email) && !isValidEmail(tenant.email)) {
    return 'Must enter a valid security contact email address';
  }

  return '';
}
